module.exports = __webpack_public_path__ + "img/icon-chevron-down.9796851c.svg";